import { ReactElement } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import referralProgramGuide from '@/assets/images/referral/benefit.png';
import referralCount from '@/assets/images/referral/referral_count.png';
import expirationDate from '@/assets/images/referral/expiration_date.png';

/**
 * 紹介プログラムの使い方モーダル本文
 * @returns 紹介プログラムの使い方モーダル
 */
function ReferralProgramGuide(): ReactElement {
    const { t } = useTranslation('referral');
    const benefitList = t('guide.sections.benefit.list', { returnObjects: true }) as string[];
    const steps = t('guide.sections.howTo.steps', { returnObjects: true }) as string[];
    const notes = t('guide.sections.notes.items', { returnObjects: true }) as string[];

    return (
        <div className="space-y-10 leading-8">
            {/* ベネフィット */}
            <div className="flex flex-col justify-center space-y-6 mt-2">
                <h3 className="text-3xl font-semibold text-gray-900 text-center pb-2">
                    {t('guide.sections.benefit.title')}
                </h3>
                <img
                    src={referralProgramGuide}
                    alt={t('guide.images.benefitAlt')}
                    className="lg:w-2/3 mx-auto rounded-xl"
                />
                <p className="text-gray-900">
                    <Trans
                        ns="referral"
                        i18nKey="guide.sections.benefit.description1"
                        components={{ br: <br /> }}
                    />
                </p>
                <p className="text-gray-900">{t('guide.sections.benefit.description2')}</p>
                <ul className="list-none pl-4 text-gray-900">
                    {benefitList.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
                <p className="text-gray-900">
                    <Trans
                        ns="referral"
                        i18nKey="guide.sections.benefit.description3"
                        components={{
                            br: <br />,
                            link: <Link to="/plans" className="text-blue-500" />,
                        }}
                    />
                </p>
            </div>
            {/* 使い方 */}
            <h3 className="text-2xl font-semibold text-gray-900">
                {t('guide.sections.howTo.title')}
            </h3>
            <ul className="list-decimal list-outside pl-8 text-gray-900">
                {steps.map((step, index) => (
                    <li key={index}>{step}</li>
                ))}
                <img
                    src={referralCount}
                    alt={t('guide.images.referralCountAlt')}
                    className="w-full mx-auto rounded-xl"
                />
                <img
                    src={expirationDate}
                    alt={t('guide.images.expirationAlt')}
                    className="w-full mx-auto rounded-xl"
                />
            </ul>
            {/* 注意事項 */}
            <h3 className="text-2xl font-semibold text-gray-900">
                {t('guide.sections.notes.title')}
            </h3>
            <ul className="list-disc list-outside pl-8 text-gray-900">
                {notes.map((note, index) => (
                    <li key={index}>{note}</li>
                ))}
            </ul>
        </div>
    );
}

export default ReferralProgramGuide;
